import { Directive, OnDestroy, Self } from '@angular/core';
import { Subscription } from 'rxjs';

import { PHX_SIZE } from '../../constants';
import { PhxBreakpointObserverService } from '../../services/phx-breakpoint-service';
import { PhxContextService } from '../../services/phx-context-service';
import { PhxContainerComponentService } from '../../services/phx-container-component.service';
import { PhxComponents } from '../../types';

/**
 * Scopes a container context to the modal header select slot so projected `phx-select`
 * children receive responsive sizing without consumers setting `phxSize`.
 *
 * Applied automatically via the `phx-modal-header-select` attribute. Provides
 * `PhxContainerComponentService` only to descendants of that wrapper — not the
 * rest of the modal — and updates the select to `small` on desktop and `medium`
 * on `sm-mobile`.
 */
@Directive({
  selector: '[phx-modal-header-select]',
  providers: [{ provide: PhxContextService, useClass: PhxContainerComponentService }],
})
export class PhxModalHeaderSelectDirective implements OnDestroy {
  private readonly _breakpointObserverSubscription: Subscription;

  constructor(
    private readonly _breakpointObserver: PhxBreakpointObserverService,
    @Self() private readonly _contextService: PhxContextService,
  ) {
    const containerService = this._contextService as PhxContainerComponentService;
    this._breakpointObserverSubscription = this._breakpointObserver.smMobile.subscribe(isMobile => {
      containerService.updateSizeMap({ [PhxComponents.Select]: isMobile ? PHX_SIZE.MD : PHX_SIZE.SM });
    });
  }

  public ngOnDestroy(): void {
    this._breakpointObserverSubscription.unsubscribe();
  }
}
